import service from '../axios'

export const consultApi = {
  // 查询咨询类型列表
  getTypes() {
    return service.get('/www/consult/types')
  },

  // 提交咨询
  submit(data) {
    return service.post('/www/consult/submit', data)
  },

  // 分页查询我的咨询（按 contactPhone）
  page(params) {
    const { contactPhone, keyword = '', status = '', page = 1, pageSize = 10 } = params
    return service.post('/www/consult/page', {
      contactPhone,
      params: {
        title: keyword,
        status: status === 'all' ? '' : status
      },
      page: { current: page, size: pageSize }
    })
  },

  // 查询咨询详情（含回复记录）
  getDetail(id, contactPhone) {
    return service.get('/www/consult/get', { params: { id, contactPhone } })
  },

  // 用户继续提问/补充说明
  reply(consultId, contactPhone, content) {
    return service.post('/www/consult/reply', { consultId, contactPhone, content })
  },

  // 用户关闭咨询
  close(consultId, contactPhone) {
    return service.post('/www/consult/close', { consultId, contactPhone })
  }
}
